<template>
    <TagPage />
</template>

<script lang="ts" setup>
    import {definePageMeta} from '#imports';
    import TagPage from '~/components/tag/TagPage.vue';

    definePageMeta({
        middleware: ['p1-query-redirect'],
    });
</script>
